import storeManager from '../../store/StoreManager';
import { deleteShape } from '../../actions/CurrentSlideActions';
import groupManager from '../utils/GroupManager';
import { setDrawState } from '../../actions/AccordionActions';
import { changeContextMode } from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import saveManager from "./SaveManager";

const drawingUtils = {
    getTouchPosition (e) {
        if (e instanceof MouseEvent) {
            return {x: e.clientX, y: e.clientY};
        } else {
            if (e.touches.length > 0)
                return {x: e.touches[0].clientX, y: e.touches[0].clientY};
            else
                return {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY};
        }
    },
    calculateStarPoints(shapeModel) {
        const centerX = shapeModel.width / 2;
        const centerY = shapeModel.height / 2;
        const arms = 5;
        const outerRadiusX = shapeModel.width / 2;
        const outerRadiusY = shapeModel.height / 2;
        const innerRadiusX = shapeModel.width / 5;
        const innerRadiusY = shapeModel.height / 5;

        var results = [];
        var angle = Math.PI / arms;
        const offsetAngle = - Math.PI / 2;
        var i;

        for (i = 0; i < 2 * arms; i++) {
            // Use outer or inner radius depending on what iteration we are in.
            var rx = (i & 1) == 0 ? outerRadiusX : innerRadiusX;
            var ry = (i & 1) == 0 ? outerRadiusY : innerRadiusY;

            var currX = centerX + Math.cos(offsetAngle + i * angle) * rx;
            var currY = centerY + Math.sin(offsetAngle + i * angle) * ry;

            results.push({x:currX, y:currY});
        }

        return results;
    },

    /**************** Drawing functionality **************************/

    currentShapes: [],
    dispatch: undefined,

    getDrawingProperties() {
        var props = {};
        const state = storeManager.getState();
        var strokeWidth = state.menu.strokeWidth;
        var strokeColor = state.menu.strokeColor;

        if (!strokeColor)
            strokeColor = 'black';

        if (!strokeWidth)
            strokeWidth = 3;

        props.strokeWidth = strokeWidth;
        props.strokeColor = strokeColor;

        return props;
    },
    addCurrentShape(shape) {
        if (!this.currentShapes)
            this.currentShapes = [];

        this.currentShapes.push(shape);
    },
    clearShapes() {
        this.currentShapes = [];
    },
    deleteShapes() {
        var shapes = [];
        var i;

        for (i=0; i<this.currentShapes.length; i++)
            shapes.push(this.currentShapes[i].uuid);

        this.dispatch(deleteShape(shapes));
        saveManager.isContentChanged(true);
    },
    groupShapes() {
        if (this.currentShapes && this.currentShapes.length > 0)
            groupManager.group(this.currentShapes);
    },
    executeAction(action) {
        if (action == 'ok') {
            const state = storeManager.getState();
            var groupDrawingShapes = state.menu.groupDrawingShapes;

            if (groupDrawingShapes == undefined)
                groupDrawingShapes = true;

            if (groupDrawingShapes)
                this.groupShapes();
        } else { // cancel
            this.deleteShapes();
        }

        this.dispatch(setDrawState('none'));
        this.dispatch(changeContextMode(modeType.CONTEXT_NONE));

        this.clearShapes();
    }
};

export default drawingUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/DrawingUtils.js
 **/